import View from "./views";
import Presenter from "./presenter";
import { ConnectComponent2 } from "util";

const states = [
  {
    name: "app.management.stock-movement-report",
    url: "/movimentacao-de-estoque",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    },
    data: {
      navigation: {
        name: "Movimentação de Estoque",
        priority: 0,
        authorization: context =>
          context.user.permissions.includes("view_closed_sales"),
        state: "app.management.stock-movement-report"
      }
    }
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/components/app/management/stock-movement-report/index.js